import * as React from "react";
import { Input, Row, Col } from "antd";
import styled, { ThemedStyledProps } from "styled-components";
import { InputProps } from "antd/lib/input";

export const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  line-height: 32px;
  font-weight: 300;
`;

type StyledInputProps = ThemedStyledProps<
  InputProps & React.RefAttributes<Input>,
  any
> & {
  hasError: boolean;
};

export const StyledInput = styled(Input)`
  ${props => (props.suffix ? "input {" : "")}
  height: 40px !important;
  background-color: #f2f2f2 !important;
  border:   ${(props: StyledInputProps) =>
    props.hasError ? "1px solid #eb0333 !important" : "none !important"}
  font-size: 14px !important;
  line-height: 32px !important;
  color: #386ee8 !important;
  font-weight: 300 !important;
  &::placeholder {
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
  ${props => (props.suffix ? "}" : "")}
`;

type Props = {
  label: React.ReactNode;
  suffix?: React.ReactNode;
  placeholder?: string;
  value?: string | string[] | number;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  hasError?: boolean;
};

export class ForwardInput extends React.Component<Props> {
  render() {
    return (
      <Row type="flex">
        <Col span={24}>
          <Label>{this.props.label}</Label>
        </Col>
        <Col span={24}>
          <StyledInput
            suffix={this.props.suffix}
            placeholder={this.props.placeholder}
            value={this.props.value}
            onChange={this.props.onChange}
            hasError={this.props.hasError || false}
          />
        </Col>
      </Row>
    );
  }
}
